import { FC } from 'react';

import { DialogTitle } from '@radix-ui/react-dialog';

import { Button } from '@/components/atoms';
import { DialogClose, DialogContent } from '@/components/atoms/Dialog/Dialog';
import { Illustrations, IllustrationVariant } from '@/components/atoms/Illustrations/Illustrations';
import { CREATE_SURVEY_POPUP_TEST_IDS } from '@/constants/data-testids';

export type CreateSurveyOption = {
  value: string | number;
  illustrationVariant: IllustrationVariant;
  title: string;
  description: string;
  button: {
    name: string;
    onClick: () => void;
  };
};

type CreateSurveyPopupProps = {
  title: string;
  options: CreateSurveyOption[];
};

export const CreateSurveyPopup: FC<CreateSurveyPopupProps> = ({ title, options }) => {
  return (
    <DialogContent showCloseButton className="w-[560px]">
      <DialogTitle className="text-body-20-semibold text-custom-warm-grey-800 mb-5">
        {title}
      </DialogTitle>
      <div className="flex items-center gap-4">
        {options.map(({ value, title, description, illustrationVariant, button }) => (
          <div
            data-testid={CREATE_SURVEY_POPUP_TEST_IDS.OPTION}
            key={value}
            className="flex flex-col items-center w-[250px] gap-5 px-4 py-6 rounded-[8px] border border-custom-warm-grey-200"
          >
            <Illustrations variant={illustrationVariant} />
            <div>
              <h6 className="text-body-16-semibold text-custom-warm-grey-800 mb-2 text-center">
                {title}
              </h6>
              <p className="text-body-14-regular text-custom-warm-grey-500 text-center">
                {description}
              </p>
            </div>
            <DialogClose asChild>
              <Button variant="primary" size="md" onClick={button.onClick}>
                {button.name}
              </Button>
            </DialogClose>
          </div>
        ))}
      </div>
    </DialogContent>
  );
};
